import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import List from './List/List'
import SSODialog from './Dialog/Dialog'
import useSSO from '../../../../../hooks/setting/useSSO'

const SSO = () => {
  const [type, setType] = useState(null)
  const [form, setForm] = useState(null)
  const permission = useSelector((state) => state?.session?.permissions?.sso || {})

  const list = useSelector((state) => state?.tenant?.sso || [])
  const { isLoadingList } = useSSO()

  const onModal = (type = null, form = {}) => {
    setType(type)
    setForm(form)
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>SSO</Typography>
        { !isLoadingList && permission['created'] && 
          <ButtonStartIcon
            onClick={() => onModal('create', {})}
            color='secondary'
            variant='contained'
            startIcon={["fas","plus"]}
          >
            Create
          </ButtonStartIcon>
        }
      </Box>
      <Box className='px-2 py-2'>
        <List
          isLoading={isLoadingList}
          list={list?.sort((a, b) => a.position - b.position) || []}
          permissions={permission}
          onModal={(type, form) => onModal(type, form)}
        />
      </Box>
      { type &&
        <SSODialog 
          type={type}
          show={!!type} 
          onClose={() => onModal(null, {})} 
          data={form || {}}
        />
      }
    </>
  )
}

export default SSO